import {
  Download,
  ExpandMore,
  Print,
  RemoveRedEye,
  Save,
} from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  Button,
  Grid,
  MenuItem,
  Stack,
  Typography,
  Divider,
} from "@mui/material";

import { FormikTextField } from "../../../components/Layout/FormikTextField";
import { StyledAccordionSummary } from "../../../styles/componentStyled";
import { CurrencyTypes, Employee } from "../types/processTypes";
import { useTranslation } from "react-i18next";
import { FormikProps } from "formik";
import CompanyUploads from "../../setups/components/CompanyUploads";
import { useEffect, useState } from "react";
import { useAppSelector } from "../../../app/hooks";
import { selectAuth } from "../../auth/authSlice";
import { AuthUser, ClientTypes } from "../../auth/types/authType";
import TestimonialSignatures from "../../setups/components/TesimonialSignatures";
import { NavLink as RouterLink } from "react-router-dom";

interface ExperienceTabProps {
  formikData: FormikProps<Employee>;
  printPdf?: any;
  printVisibility?: string;
  downloadKuwaitContract?: any;
}

export const VisaBriefKuwait = ({
  formikData,
  printPdf,
  printVisibility,
  downloadKuwaitContract,
}: ExperienceTabProps) => {
  const { t: te } = useTranslation("enums");
  const { t } = useTranslation();
  const { user } = useAppSelector(selectAuth) as { user: AuthUser };

  const [agencyId, setAgencyId] = useState<string>();
  const [agencyName, setAgencyName] = useState<string>("");
  const [agentId, setAgentId] = useState<string>();
  const [agentName, setAgentName] = useState<string>("");

  useEffect(() => {
    if (user && user.company && user.company._id) {
      setAgencyId(user.company._id as string);
      setAgencyName(user.company.displayName);
    } else {
      setAgencyId(undefined);
    }
  }, [user]);

  useEffect(() => {
    if (
      formikData &&
      formikData.values &&
      formikData.values.prospects &&
      formikData.values.prospects.length > 0 &&
      formikData.values.prospects[0]._id
    ) {
      setAgentId(formikData.values.prospects[0]._id as string);
      setAgentName(formikData.values.prospects[0].displayName);
    } else {
      setAgentId(undefined);
    }
  }, [formikData]);

  return (
    <Stack>
      <Accordion expanded>
        <StyledAccordionSummary
          expandIcon={<ExpandMore />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant="h6" component="div">
            Kuwait Contract Entry
          </Typography>
        </StyledAccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item sm={8} xs={12} hidden>
              {/* <CompanyFilter
                companyType={ClientTypes.ForeignAgent}
                setCompany={setCompany}
              /> */}
            </Grid>

            {/* <Grid item md={4} xs={12} hidden>
              <TextField
                id="visaVisaNumber"
                name="visa.visaNumber"
                label="Visa Number"
                value={1111111111}
                hidden
              />
            </Grid> */}
            {/* <Grid item md={4} xs={12} hidden>
                <TextField
                  id="visaPassportNumber"
                  name="visa.passportNumber"
                  label="Employer Id"
                  value={"9999999999"}
                  hidden
                />
              </Grid> */}
            <Grid item md={6} xs={12}>
              <FormikTextField
                formikKey="visa.fullName"
                label="Employer Full Name"
              />
            </Grid>

            <Grid item md={2} xs={12}>
              <FormikTextField
                formikKey="visa.address.telephone"
                label="Employer Telephone"
              />
            </Grid>
            <Grid item md={2} xs={12}>
              <FormikTextField
                formikKey="visa.address.city"
                label="Employer city"
              />
            </Grid>
            <Grid item md={2} xs={12}>
              <Stack direction="row">
                <FormikTextField
                  formikKey="additionalData.salary"
                  label={t("salary")}
                  type="number"
                  sx={{ mr: 0.3, mt: 1 }}
                />
                <FormikTextField
                  formikKey="additionalData.currency"
                  select
                  label={te("currency")}
                >
                  {Object.keys(CurrencyTypes).map((option) => (
                    <MenuItem key={option} value={option as string}>
                      {te(option)}
                    </MenuItem>
                  ))}
                </FormikTextField>
              </Stack>
            </Grid>
          </Grid>

          <Stack
            direction={{ xs: "column", md: "row" }}
            alignItems="flex-start"
            spacing={2}
          >
            <Grid container md={6} xs={12} spacing={2}>
              <Grid item md={12} xs={12}>
                <Divider variant="fullWidth" textAlign="left" sx={{ mt: 2 }}>
                  Testimonials/ምስክሮች
                </Divider>
              </Grid>

              <Grid item md={6} xs={12}>
                <FormikTextField
                  formikKey="firstTestimonialName"
                  label="First Testimonial Name"
                />
              </Grid>
              <Grid item md={3} xs={12}>
                <FormikTextField
                  formikKey="firstTestimonialAddress"
                  label=" Address"
                />
              </Grid>
              <Grid item md={3} xs={12}>
                <FormikTextField
                  formikKey="firstTestimonialTelephone"
                  label=" Telephone"
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <FormikTextField
                  formikKey="secondTestimonialName"
                  label="Second Testimonial Name"
                />
              </Grid>
              <Grid item md={3} xs={12}>
                <FormikTextField
                  formikKey="secondTestimonialAddress"
                  label=" Address"
                />
              </Grid>
              <Grid item md={3} xs={12}>
                <FormikTextField
                  formikKey="secondTestimonialTelephone"
                  label=" Telephone"
                />
              </Grid>
              <Grid item md={4} xs={12}>
                <FormikTextField
                  formikKey="visa.visaNumber"
                  label={"Visa Number (optional)"}
                />
              </Grid>
              <Grid item md={4} xs={12}>
                <FormikTextField
                  formikKey="visa.passportNumber"
                  label={"Employer Id (optional)"}
                />
              </Grid>
              <Grid item md={4} xs={12}>
                <FormikTextField
                  formikKey="education.yearCompleted"
                  label={t("referenceNumber") + " (optional)"}
                />
              </Grid>
            </Grid>

            <Grid
              container
              md={6}
              xs={12}
              spacing={2}
              justifyContent="space-between"
            >
              <Grid container item xs={12} spacing={2}>
                <Grid item md={12} xs={12}>
                  <Divider variant="fullWidth" textAlign="left">
                    Emergency Contact Person
                  </Divider>
                </Grid>
                <Grid item md={6} xs={12}>
                  <FormikTextField
                    formikKey="contactPerson.displayName"
                    label="Emergency Person Name"
                  />
                </Grid>
                <Grid item md={3} xs={12}>
                  <FormikTextField
                    formikKey="contactPerson.address.city"
                    label=" Address"
                  />
                </Grid>
                <Grid item md={3} xs={12}>
                  <FormikTextField
                    formikKey="contactPerson.address.telephone"
                    label=" Telephone"
                  />
                </Grid>
              </Grid>
              <Grid item md={4} xs={12}>
                <Button
                  type="submit"
                  color="secondary"
                  variant="contained"
                  disabled={!formikData.isValid}
                  size="large"
                  sx={{ width: "100%" }}
                >
                  <Save />
                  {t("save")}
                </Button>
              </Grid>
              <Grid item md={4} xs={12}>
                <Button
                  color="primary"
                  variant="contained"
                  component={RouterLink}
                  to={"/app/k/" + formikData.values._id}
                  size="large"
                  sx={{ display: printVisibility, width: "100%" }}
                >
                  <Download /> New Contract
                </Button>
                {/* <Button
                  color="secondary"
                  variant="contained"
                  onClick={printPdf}
                  size="large"
                  sx={{ display: printVisibility, width: "100%" }}
                >
                  <Print /> Print Contract
                </Button> */}
              </Grid>
              <Grid item md={4} xs={12}>
                <Button
                  color="secondary"
                  variant="contained"
                  onClick={downloadKuwaitContract}
                  size="large"
                  sx={{ display: printVisibility, width: "100%" }}
                >
                  <Download /> Old Contract
                </Button>
              </Grid>
            </Grid>
          </Stack>
        </AccordionDetails>
      </Accordion>
      {agencyId && agentId && agencyId !== agentId && (
        <Stack>
          <Accordion expanded>
            <StyledAccordionSummary
              expandIcon={<ExpandMore />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography variant="h6" component="div">
                Stamps and Signatures
              </Typography>
            </StyledAccordionSummary>
            <AccordionDetails>
              <Grid
                container
                xs={12}
                spacing={2}
                justifyContent="space-between"
              >
                <Grid
                  item
                  md={5}
                  xs={12}
                  spacing={2}
                  justifyContent="space-between"
                  sx={{ borderRight: "solid 1px #E0E0E0" }}
                >
                  <Divider variant="fullWidth" textAlign="left">
                    <Typography
                      variant="body1"
                      color="secondary"
                      component="span"
                    >
                      {agencyName}
                    </Typography>
                  </Divider>
                  <CompanyUploads
                    key={`agency-${agencyId}`}
                    companyId={agencyId}
                    type={ClientTypes.LocalAgency}
                  />
                </Grid>
                <Grid
                  item
                  md={5}
                  xs={12}
                  spacing={2}
                  justifyContent="space-between"
                  sx={{ borderRight: "solid 1px #E0E0E0" }}
                >
                  <Divider variant="fullWidth" textAlign="left">
                    <Typography
                      variant="body1"
                      color="secondary"
                      component="span"
                      noWrap={false}
                    >
                      {agentName}
                    </Typography>
                  </Divider>
                  <CompanyUploads
                    key={`agent-${agentId}`}
                    companyId={agentId}
                    type={ClientTypes.ForeignAgent}
                  />
                </Grid>
                <Grid
                  item
                  md={2}
                  xs={12}
                  spacing={2}
                  justifyContent="space-between"
                >
                  <Divider variant="fullWidth" textAlign="left">
                    <Typography
                      variant="body1"
                      color="secondary"
                      component="span"
                    >
                      Testimonial Signatures
                    </Typography>
                  </Divider>
                  <TestimonialSignatures
                    key={`testimonials-${agencyId}`}
                    companyId={agencyId}
                  />
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
          {/* <Accordion expanded>
            <StyledAccordionSummary
              expandIcon={<ExpandMore />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography variant="h6" component="div">
                {agentName}
              </Typography>
            </StyledAccordionSummary>
            <AccordionDetails>
              <CompanyUploads
                key={`agent-${agentId}`}
                companyId={agentId}
                type={ClientTypes.ForeignAgent}
              />
            </AccordionDetails>
          </Accordion>
          <Accordion expanded>
            <StyledAccordionSummary
              expandIcon={<ExpandMore />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography variant="h6" component="div">
                Testimonial Signatures
              </Typography>
            </StyledAccordionSummary>
            <AccordionDetails>
              <TestimonialSignatures
                key={`testimonials-${agencyId}`}
                companyId={agencyId}
              />
            </AccordionDetails>
          </Accordion> */}
        </Stack>
      )}
    </Stack>
  );
};
